/**
 * Auth Event Utilities
 *
 * Emits auth events for AuthProvider to handle navigation
 * apiClient no longer handles navigation directly
 */

export type AuthEventType = "expired" | "unauthorized";

/**
 * Emit auth events for AuthProvider to handle navigation
 * FIXED: apiClient no longer handles navigation directly
 */
export function emitAuthEvent(eventType: AuthEventType, error?: string) {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(`auth:${eventType}`, {
      detail: { error },
    }),
  );
}
